<template>
    <FontAwesomeIcon
        :icon="iconParse"
        :size="size"
    />
</template>

<script type="text/javascript">
// This component has been created to allow conditional icon display with vue font awesome icons.

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    name: 'FAIcon',
    components: {
        FontAwesomeIcon
    },
    props: {
        icon: {
            required: true,
        },
        size: {
            required: false,
            default: undefined
        },
    },
    computed: {
        iconParse() {
            if (
                (typeof this.icon === 'string' || this.icon instanceof String)
                || Array.isArray(this.icon)
            ) return this.icon

            if (
                typeof this.icon === 'object'
                && this.icon !== null
            ) {
                for (let [icon, condition] of Object.entries(this.icon)) {
                    if (condition) return icon
                }

                throw new Error('When using an object with FAIcon, you must ensure that one icon\'s condition is always true.')
            }
        },
    },
}
</script>
